export const omit = (callback, predicate) => (...args) => {
    if (!predicate(...args)) {
        callback(...args);
    }
};

export const once = (callback) => {
    let called = false;

    return (...args) => {
        if (!called) {
            callback(...args);
            called = true;
        }
    };
};
